import { render } from "./BasketballMatchContent.vue?vue&type=template&id=2e60fa18&scoped=true"
import script from "./BasketballMatchContent.vue?vue&type=script&lang=js"
export * from "./BasketballMatchContent.vue?vue&type=script&lang=js"

import "./BasketballMatchContent.vue?vue&type=style&index=0&id=2e60fa18&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/production-allsports-2/production-as-fe-ASPN/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e60fa18"]])

export default __exports__